<template>
	<div class="content">
		<!-- <header1 :pathname="pathname" @showMobile="showMobile"></header1> -->
		<!-- <swiper
		     v-if="list.length > 0"
		      class="swiper-container"
		      @swiper="onSwiper"
		      @slideChange="onSlideChange"
		      :modules="modules"
		      :pagination="{ clickable: true }"
		      :autoplay="{
				  disableOnInteraction: false,
		      delay: 4000,
		      }"
			  :direction= 'horizontal'
		      :navigation="false"
		      :loop="true"
		  >
		    <swiper-slide class="banneren"  v-for="(item, index) in list" :key="index">
		      <img class="item"  :src="item.carouselUrl"/>
			  <div class="banner-sec">
				  <div>Corporate mission, technology empowerment, lighting up a green future</div>
			  </div>
		    </swiper-slide>
			<div class="pagination">
				<div v-for="(item, index) in list.length" :key="index" :class="cIndex == index?'sdiv':''"></div>
			</div>
		  </swiper> -->
		<hheader1 :pathname="pathname" @showMobile="showMobile"></hheader1>  
		<swiper v-if="list.length > 0" class="swiper-container"
		    :style="{height:screenW>880?screenH:'auto'}, {width:+ '100%;'}" @swiper="onSwiper" @slideChange="onSlideChange"
			:modules="modules" :pagination="{ clickable: true }" :autoplay="{
		      disableOnInteraction: false,
		      delay: 4000,
		      }" :direction='horizontal' :navigation="false" :loop="true">
			<swiper-slide class="banner" style="width: 100%; height: 100%;" v-for="(item, index) in list" :key="index">
				<img :src="item.carouselUrl"/><!-- style="object-fit: contain;" -->
				<div class="banner-sec">
					<div>Corporate mission, technology empowerment, lighting up a green future</div>
				</div>
			</swiper-slide>
			<div class="pagination">
				<div v-for="(item, index) in list.length" :key="index" :class="cIndex == index?'sdiv':''"></div>
			</div>
		</swiper>

		<!-- 公司详情 -->
		<div class="gs">
			<div class="gs-cc">
				<div class="gs-c-l">
					<img src="../../assets/newimg/202.jpg" alt="">
					<div class="gs-c-l-f">
						<div class="item">
							<div class="item-h">{{num1}} <span>thousand</span> </div>
							<div class="item-f">registered capital</div>
						</div>
						<div class="item">
							<div class="item-h">Level 2</div>
							<div class="item-f">general contractor</div>
						</div>
						<div class="item">
							<div class="item-h">Level 4</div>
							<div class="item-f">Undertake decoration</div>
						</div>
						<div class="item">
							<div class="item-h">{{num2}} <span>W</span></div>
							<div class="item-f new-item-f">Accumulated installed capacity</div>
						</div>
					</div>
				</div>
				<div class="gs-c-r">
					<div class="title new-title">
						Zhejiang Zhonggai Electric Power Technology Co., Ltd
					</div>
					<div class="sec new-sec" style="letter-spacing: 2px;">
						Zhejiang Zhonggai Electric Power Technology Co., Ltd. was founded in 2015 and is a high-tech enterprise specializing in new energy fields such as wind and photovoltaic power generation and energy storage. The company integrates technology research and development, project development and investment, system design and integration, construction and operation, and focuses on investment and construction in five core sectors: photovoltaics, energy storage, decentralized wind power, electricity, and operation and maintenance.
					</div>
					<div class="more new-more" style="cursor: pointer;">
						<div id="morebtn" @click="goabout(0)">See more</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 业务与服务 -->
		<div class="fw">
			<div class="fw-cc">
				<div class="fw-h">Service</div>
				<div class="fw-b">
					
					<img src="../../assets/home/业务与服务-英文111.png" alt="">

				</div>
				<div class="fw-more" style="margin-top: 70px;cursor: pointer;"> 
					<div id="morebtn111" @click="goservice">See more</div>
				</div>
			</div>
		</div>

		<!-- 新闻媒体 -->
		<div class="mt">
			<div class="mt-cc">
				<div class="mt-h">Medium</div>
				<div class="mt-b">
					<div class="item" style="cursor: pointer;" v-for="(item, index) in xwlist.slice(0,3)" :key="index"
					@click="tapMediumDetails(item)">
						<img :src="item.barticleUrl" alt="">
						<div class="item-t">
							{{item.barticleTile}}
						</div>
						<div class="item-s">
							{{item.createTime.split('00:00:00')[0]}}
						</div>
					</div>
				</div>
				<div class="mt-more" style="margin-top: 70px;cursor: pointer;">
					<div id="morebtn" @click="goMedium">See more</div>
				</div>
			</div>
		</div>

		<!-- 合作伙伴 -->
		<div class="hb">
			<div class="hb-cc">
				<div class="hb-h">Cooperative partner</div>
				<div class="hb-b">
					<img class="item-h" src="../../assets/hezuo/11@2x.png" alt="">
					<img class="item-h" src="../../assets/hezuo/12@2x.png" alt="">
					<img class="item-h" src="../../assets/hezuo/13@2x.png" alt="">
					<img class="item-h" src="../../assets/hezuo/14@2x.png" alt="">
					<img class="item-h" src="../../assets/hezuo/15@2x.png" alt="">
					<img class="item-h" src="../../assets/hezuo/16@2x.png" alt="">
					<img class="item-h" src="../../assets/hezuo/21@2x.png" alt="">
					<img class="item-h" src="../../assets/hezuo/22@2x.png" alt="">
					<img class="item-h" src="../../assets/hezuo/23@2x.png" alt="">
					<img class="item-h" src="../../assets/hezuo/24@2x.png" alt="">
					<img class="item-h" src="../../assets/hezuo/25@2x.png" alt="">
					<img class="item-h" src="../../assets/hezuo/26@2x.png" alt="">
					<img class="item-h" src="../../assets/hezuo/31@2x.png" alt="">
					<img class="item-h" src="../../assets/hezuo/32@2x.png" alt="">
					<img class="item-h" src="../../assets/hezuo/33@2x.png" alt="">
					<img class="item-h" src="../../assets/hezuo/34@2x.png" alt="">
					<img class="item-h" src="../../assets/hezuo/35@2x.png" alt="">
					<img class="item-h" src="../../assets/hezuo/36@2x.png" alt="">

				</div>
				<div class="hb-more" style="margin-top: 70px;cursor: pointer;">
					<div id="morebtn" @click="gocase">See more</div>
				</div>
			</div>
		</div>

		<!-- 资质荣誉 -->
		<div class="ry">
			<div class="ry-cc">
				<div class="ry-h">Qualification and Honor</div>
				<div class="ry-b">
					<img class="ry-b-l" style="cursor: pointer;" src="../../../public/imgs/home/编组 6@2x.png" alt="">
					<div class="ry-b-c">
						<div class="item" @click="handlePreview(item.barticleUrl)" v-for="(item, index) in currentImages" :key="index">
							<img class="item-h" style="object-fit: contain;" :src="item.barticleUrl" alt="">
							<img class="item-f" src="../../../public/imgs/3881735286132_.pic.jpg" alt="">
						</div>
					</div>
					<img class="ry-b-r" style="cursor: pointer;" src="../../../public/imgs/home/编组 6@2x(1).png" alt="">
				</div>
				<div class="ry-more" style="cursor: pointer;">
					<div id="morebtn" @click="goabout(2)">See more</div>
				</div>
			</div>
		</div>

		<!-- 投资模式 -->
		<div class="tz">
			<div class="tz-cc">
				<div class="tz-h">Investment model</div>
				<div class="tz-b">  
					<div class="item">
						<img class="bgimg" src="../../assets/home/蒙版@2x.png" alt="">
						<div class="item-t" >
							Energy management mode
						</div>
						<div class="item-s">
							Owners rent roofs or land, companies invest in the construction and operation of power stations, and owners enjoy electricity discounts or rent;
						</div>
						<div class="item-b" id="investBtn"  style="cursor: pointer; color: white;  background-color: #22A3D3;" @click="goservice">
							invest
						</div>
					</div>
					<div class="item">
						<img class="bgimg" src="../../assets/home/home2.png" alt="">
						<div class="item-t">
							Joint venture and co construction model
						</div>
						<div class="item-s">
							The investment or project company is jointly established by the owner or partner and the company to jointly invest in the construction and operation of the power station, with the partner sharing the profits.
						</div>
						<div class="item-b"id="investBtn" style="cursor: pointer; color: white;  background-color: #22A3D3;" @click="goservice">
							invest
						</div>
					</div>
				</div>
			</div>
		</div>
		<footer1></footer1>
		
		<div v-if="isShowImg" class="preImg">
			<img :src="showImg" alt="" @click="closeViewer"/>
		</div>
		
		<mobilemenu v-if="isShowMobile" @hiddenMobile="hiddenMobile"></mobilemenu>
	</div>
</template>

<script>
	import mobilemenu from "@/components/en/mobile-menu.vue";
	import hheader1 from "@/components/en/hheader.vue";
	
	import footer1 from "@/components/en/footer.vue";
	
	import {Swiper, SwiperSlide} from 'swiper/vue';
	import {Navigation, Pagination, A11y, Autoplay} from 'swiper/modules';
	import 'swiper/css';
	import 'swiper/css/navigation';
	import 'swiper/css/pagination';
	import 'swiper/css/autoplay';
	
	import {
	  carousellisten,
	  carousellist,
	  contentlisten,
	  contentlist
	} from '@/api/home.js';
	


	export default {
		components: {
			hheader1,
			footer1,
			Swiper,
			SwiperSlide,
			mobilemenu
		},
		data() {
			return {
				num1: 0,
				num2: 0,
				increment1: 20, // 每次增加的数值
				increment: 50, // 每次增加的数值
				intervalId1: null,
				
				currentStartIndex: 0, // 当前显示图片的起始索引
				imagesPerBatch: 4 ,
				
				isShowImg:false,
				showImg:"",
				
				modules : [ A11y, Autoplay],
				isShowMobile:false,
				pathname:"/en/index",
				images: ["1", "2", "3"],
				swiperOptions: {
					// 设置分页器
					autoplay: true,//自动播放（有的版本）
					loop: true,//是否循环播放
					pagination: {
						el: '.swiper-pagination',
						clickable: true // 允许分页点击
					},
				},
				list:[],
				xwlist:[],
				rylist:[],
				cIndex:0,
				
				startIndex:0,
				endIndex:3,
				screenW:0,
				screenH:0
			}
		},
		created(e) {
            this.getcarousellist()
			this.getxwcontentlist()
			this.getrycontentlist()
			this.getScreenSize()
			var that = this
				this.intervalId1 = setInterval(function(){
					
					if(that.num2 < 1000) {
						that.num2 += that.increment1;
					}
					
					if (that.num1 < 5000) {
						that.num1 += that.increment;
					} else {
						clearInterval(that.intervalId1); // 达到目标值后清除定时器
					}
				}, 80);
			
			},
			beforeDestroy() {
				clearInterval(this.intervalId1); // 清除定时器，避免内存泄漏
				
			},
		computed: {
		    currentImages() {
		      return this.rylist.slice(this.currentStartIndex, this.currentStartIndex + this.imagesPerBatch);
		    }
		  },
		methods: {
			getScreenSize() {
			      const width = window.innerWidth;
			      const height = window.innerHeight;
				  this.screenW = width
				  this.screenH = height+"px"
			      console.log(this.screenH, "this.screenH");
			}, 
			next() {
			      if (this.currentStartIndex + this.imagesPerBatch < this.rylist.length) {
			        this.currentStartIndex += this.imagesPerBatch;
			      } else {
			        // 如果已经到最后一组，可以选择重置或者停止加载更多图片等逻辑
			        this.currentStartIndex = 0; // 重置为第一组
			      }
			    },
			    prev() {
			      if (this.currentStartIndex >= this.imagesPerBatch) {
			        this.currentStartIndex -= this.imagesPerBatch;
			      } else {
			        // 如果已经到第一组，可以选择重置或者停止加载更多图片等逻辑
			        this.currentStartIndex = (Math.floor((this.rylist.length - 1) / this.imagesPerBatch) * this.imagesPerBatch); // 设置为最后一组第一张图片的索引
			      }
			    },
			handlePreview(url) {
				this.showImg = url
			      this.isShowImg = true
			    },
			    // 关闭查看器
			    closeViewer() {
			      this.isShowImg = false
			    },
			onSwiper(e){
			
			},
			onSlideChange(e){
				
				this.cIndex = e.realIndex
			},
			hiddenMobile(){
				this.isShowMobile = false
			},
			showMobile() {
				this.isShowMobile = true
			},
			getcarousellist(){
				carousellist({
				  pageNum: this.pageNum,
								pageSize:10,
								companyId:1
				}).then(res => {
				  if (res.data.code == 200) {
				    this.list = res.data.rows
				  }
				})
			},
			getxwcontentlist(){
				contentlisten({
				    pageNum: this.pageNum,
					pageSize:3,   
					companyId:1,
					categoryId:442
				}).then(res => {
				  if (res.data.code == 200) {
				    this.xwlist = res.data.rows
				  }
				})
			},
			getrycontentlist(){
				contentlist({
				    pageNum: 1,
					pageSize:4,
					companyId:1,
					categoryId:429
				}).then(res => {
				  if (res.data.code == 200) {
				    this.rylist = res.data.rows
					
					this.startIndex = 0
					this.endIndex = 3
				  }
				})
			},
			tapprev(){
				
			},
			tapMediumDetails(item) {
				this.$router.push({path:"/en/mediumdetails", query:{ id: item.bid }}) 
			},
			goMedium() {
				this.$router.push({path:"/en/medium"}) 
			},
			goabout(index) {
				this.$router.push({path:"/en/about", query:{ index: index }}) 
			},
			goservice() {
				this.$router.push({path:"/en/service"}) 
			},
			gocase(){
				this.$router.push({path:"/en/case"}) 
			},
			
			
			

		}
	}
</script>

<style lang="scss">
	.content {
		
		.preImg {
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: rgba(0, 0, 0, 0.5);
			z-index: 9999;
			img {
				width: 50%;
				height: 80%;
				object-fit: contain;
			}
		}
		
		.banneren {
			position: relative;
			.banner-sec {
				position: absolute;
				top: 0;
				left:0;
				width:100%;
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				color: white;
				text-align: center;
			}
		}


		.gs {
			background-color: #FFFFFF;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;
			

			.gs-cc {
				justify-content: space-between;

				.gs-c-l {
					

					.gs-c-l-f {
						
						justify-content: space-between;
						align-items: center;

						.item {
							flex: 1;
							text-align: center;

							.item-h {
								font-family: BebasNeue-Regular;
								font-weight: 400;
								color: #22A3D3;
								cursor: pointer;

								span {
									color: #22A3D3;
								}
							}

							.item-f {
								font-weight: 400;
								color: #22A3D3;
							}
						}
					}
				}

				.gs-c-r {
					
					flex-direction: column;
					justify-content: flex-start;

					.title {
						font-weight: 500;
						color: #332C2B;
					}

					.sec {
						font-weight: 400;
						
						color: #332C2B;
					}

					.more {
					
						justify-content: center;
						align-items: center;

						div {
						
							color: #22A3D3;
							text-align: center;
							
						}
					}
				}
			}
		}

		// 业务与服务
		.fw {
			background-color: #F3F9F9;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		
			box-sizing: border-box;

			

			.fw-h {
				
				text-align: center;
				color: #333;
			}

			.fw-b {
			
				
				justify-content: center;
				align-items: center;
				flex-wrap: wrap;

               

			}

			.fw-more {
				
				justify-content: center;
				align-items: center;

				#morebtn111 {
				
					color: #22A3D3;
					text-align: center;
				
				}
				#morebtn111:hover {
				    background-color: #22A3D3;
					color: white;
					
				}
			}
		}

		//新闻媒体
		.mt {
			background-color: #FFFFFF;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;

			

			.mt-h {
				
				text-align: center;
				color: #333;
			}

			.mt-b {
				
				justify-content: space-between;
				// align-items: center;
				flex-wrap: wrap;

				.item {
					
					.item-t {
						
						color: #332C2B;
					}

					.item-s {
					
						color: #999999;
					}
				}

			}

			.mt-more {
			
				justify-content: center;
				align-items: center;

				div {
				
					color: #22A3D3;
					text-align: center;
					
				}
			}
		}

		// 合作伙伴
		.hb {
			
			background-color: rgba(34, 163, 211, 0.05);
			flex-direction: column;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;

		

			.hb-h {
				
				text-align: center;
				color: #333;
			}

			.hb-b {
				
				justify-content: flex-start;
				align-items: center;
				flex-wrap: wrap;

				


			}

			.hb-more {
				
				justify-content: center;
				align-items: center;

				div {
				
					color: #22A3D3;
					text-align: center;
		
				}
			}
		}

		// 资质荣誉
		.ry {
			background-color: #FFFFFF;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;

			
			.ry-h {
				
				text-align: center;
				color: #333;
			}

			.ry-b {
				
				justify-content: space-between;
				align-items: center;

				

				.ry-b-c {
					
					justify-content: space-between;
					align-items: center;

					.item {
						
						flex-direction: column;
						justify-content: center;
						align-items: center;

						
					}

				}


			}

			.ry-more {
				justify-content: center;
				align-items: center;
				cursor: pointer;

				div {
					
					color: #22A3D3;
					text-align: center;
					
				}
			}
		}

		// 投资模式
		.tz {

			background-color: #F3F9F9;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.tz-cc {
			
			}

			.tz-h {
				
				text-align: center;
				color: #333;
			}

			.tz-b {
				display: flex;
				justify-content: space-between;
				align-items: center;

				.item {
				
					box-sizing: border-box;
					position: relative;
					
					// background-image:url(../../public/imgs/home/蒙版@2x.png);
					.bgimg {
						position: absolute;
						
						z-index: 0;
					}

					.item-t {
						color: #fff;
						position: relative;
						z-index: 3;
					}

					.item-s {
				
						color: #FFFFFF;
						position: relative;
						z-index: 3;
					}

					.item-b {
						margin-top: 24px;
						position: relative;
						z-index: 3;
				
					
						text-align: center;
						color: #22A3D3;
			
					}
				}
			}
		}
	}

	.swiper-container {
		
		position: relative;
		.pagination {
			position: absolute;
			
			z-index: 999;
			display: flex;
			justify-content: center;
			div {
				
				background: #ffffff4d;
				border-radius: 4px;
				margin: 0 5px;
			}
			.sdiv {
				background: #FFFFFF;
			}
		}
	}

	.swiper-slide {
		
		.banner {
			
			position: relative;
			justify-content: center;
			align-items: center;
			img {
				position: absolute;
				
				z-index: -1;
			}
			div {
				text-align: center;
				
				color: #FFFFFF;
			}
		}
		
		object-fit: cover;
		
		display: block;
	}

	.swiper-pagination-bullet {
		
		text-align: center;
		background-color: #fff;
		opacity: 1;
		/* 样式自定义，比如可以加边框等 */
	}

	/* 激活状态下的下标样式 */
	.swiper-pagination-bullet-active {
		background-color: #000;
	}
	
	#morebtn:hover {
		background-color: #22A3D3;
		color: white;
	}
	#investBtn:hover {
		background-color: #22A3D3;
		color: white;
		border: 0;
	}
	
	
	@media screen and (min-width: 1200px) {
		.content {
			// padding-top: 100px;
			
			.banneren {
				.banner-sec {
					
					div {
						font-size: 28px;
					}
				}
			}
		
			.gs {
				width: 100%;
				display: flex;
				padding-bottom: 80px;
				padding: 120px 0 60px;
		
				.gs-cc {
					width: 1200px;
					display: flex;
		
					.gs-c-l {
						width: 60%;
		
						img {
							width: 100%;
						}
		
						.gs-c-l-f {
							margin-top: 39px;
							display: flex;
		
							.item {
								flex: 1;
								text-align: center;
		
								.item-h {
									font-weight: 400;
									font-size: 40px;
		
									span {
										font-size: 15px;
									}
								}
		
								.item-f {
									font-weight: 400;
									font-size: 16px;
									&.new-item-f{
										font-size:12px;
									}
								}
							}
						}
					}
		
					.gs-c-r {
						width: calc(40% - 30px);
						display: flex;
		
						.title {
							font-weight: 500;
							font-size: 30px;
							margin-bottom: 10px;
							&.new-title{
								font-size:24px;
							}
						}
		
						.sec {
							font-weight: 400;
							font-size: 17px;
							&.new-sec{
								font-size:15px;
							}
						}
		
						.more {
							margin-top: 54px;
							width: 100%;
							display: flex;
							&.new-more{
								margin-top:30px;
							}
							div {
								width: 220px;
								height: 57px;
								border: 1px solid #22A3D3;
								line-height: 57px;
								border-radius: 2px;
							}
						}
					}
				}
			}
		
			// 业务与服务
			.fw {
				width: 100%;
				display: flex;
				padding-bottom: 80px;
		
				.fw-cc {
					width: 1200px;
				}
		
				.fw-h {
					height: 180px;
					line-height: 180px;
					font-size: 32px;
				}
		
				.fw-b {
					width: 100%;
					display: flex;
		
		            img {
						width: 80%;
						// height:544px;
						margin-top:40px;
						margin-bottom:20px;
					}
		
				}
		
				.fw-more {
					width: 100%;
					display: flex;
		
					div {
						width: 220px;
						height: 57px;
						border: 1px solid #22A3D3;
						line-height: 57px;
						border-radius: 2px;
					}
				}
			}
		
			//新闻媒体
			.mt {
				width: 100%;
				display: flex;
				padding-bottom: 80px;
		
				.mt-cc {
					width: 1200px;
				}
		
				.mt-h {
					height: 180px;
					line-height: 180px;
					font-size: 32px;
				}
		
				.mt-b {
					width: 100%;
					display: flex;
					justify-content: space-between;
		
					.item {
						width: calc(33.33% - 10px);
		
						img {
							width: 100%;
							height: 320px;
						}
		
						.item-t {
							margin-top: 25px;
							font-size: 26px;
						}
		
						.item-s {
							margin-top: 16px;
							font-size: 16px;
						}
					}
		
				}
		
				.mt-more {
					width: 100%;
					display: flex;

					div {
						width: 220px;
						height: 57px;
						border: 1px solid #22A3D3;
						line-height: 57px;
						border-radius: 2px;
					}
				}
			}
		
			// 合作伙伴
			.hb {
				width: 100%;
				display: flex;
				padding-bottom: 80px;
		
				.hb-cc {
					width: 1200px;
				}
		
				.hb-h {
					height: 180px;
					line-height: 180px;
					font-size: 32px;
				}
		
				.hb-b {
					width: 100%;
					display: flex;
		
					img {
						width: 16.6%;
						height:8%;
						// height: 120px;
					}
		
		
				}
		
				.hb-more {
					width: 100%;
					display: flex;
		
					#morebtn {
						width: 220px;
						height: 57px;
						border: 1px solid #22A3D3;
						line-height: 57px;
						border-radius: 2px;
					}
				}
			}
		
			// 资质荣誉
			.ry {
				width: 100%;
				display: flex;
				padding-bottom: 80px;
		
				.ry-cc {
					width: 1200px;
					min-width: 1200px;
				}
		
				.ry-h {
					height: 180px;
					line-height: 180px;
					font-size: 32px;
				}
		
				.ry-b {
					width: 100%;
					display: flex;
		
					.ry-b-l,
					.ry-b-r {
						width: 55px;
						height: 55px;
					}
		
					.ry-b-c {
						width: calc(100% - 200px);
						display: flex;
		
						.item {
							width: calc(25% - 30px);
							display: flex;
		
							.item-h {
								width: 90%;;
								height: 220px;
							}
		
							.item-f {
								width: 100%;
								height: 108px;
							}
						}
		
					}
		
		
				}
		
				.ry-more {
					width: 100%;
					display: flex;		
					div {
						width: 220px;
						height: 57px;
						border: 1px solid #22A3D3;
						line-height: 57px;
						border-radius: 2px;
					}
				}
			}
		
			// 投资模式
			.tz {
		
				width: 100%;
				display: flex;
				padding-bottom: 80px;
		
				
		
				.tz-h {
					height: 180px;
					line-height: 180px;
					font-size: 32px;
				}
		
				.tz-b {
					width: 1200px;
					display: flex;		
					.item {
						 transition: transform 0.3s;
						width: calc(50% - 20px);
						height: 500px;
						padding: 40px;
						
						.bgimg {
							top: 0;
							left: 0;
							width: 100%;
							height: 500px;
						}
		
						.item-t {
							font-size: 32px;
						}
		
						.item-s {
							width: 400px;
							margin-top: 15px;
							font-size: 18px;
						}
		
						.item-b {
							margin-top: 24px;
							width: 220px;
							height: 55px;
							border: 1px solid #22A3D3;
							line-height: 55px;
							border-radius: 2px;
						}
					}
					.item:hover {
					       transition: width 0.3s, height 0.3s;
					       transform: scale(0.95);
					       
					      }
				}
			}
		}
		
		.swiper-container {
			width: 100%;
			// height: 650px;
			height: 100vh !important;
			.pagination {
				bottom: 30px;
				left:calc(50% - 150px);
				width: 300px;
				height: 20px;
				
				div {
					width: 24px;
					height: 7px;
					
					margin: 0 5px;
				}
				
			}
		}
		
		.swiper-slide {
			width: 100%;
			// height: 650px;
			height: 100%;
			img {
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}
			.banner {
				width: 100%;
				height: 650px;
				display: flex;
				img {
					top: 0;
					left: 0;
					width: 100%;
					height: 650px;
				}
				div {
					width: 100%;
					font-size: 48px;
				}
			}
		}
		
		.swiper-pagination-bullet {
			width: 20px;
			height: 20px;
		}
		
	
	}
	@media screen and (max-width: 1200px) {
		.content {
			// padding-top: 80px;
			.banneren {
				.banner-sec {
					div {
						font-size: 22px;
					}
				}
			}
		
			.gs {
				width: 100%;
				display: flex;
				padding-bottom: 80px;
				padding: 60px 20px 40px;
		
				.gs-cc {
					width: 100%;
					display: flex;
		
					.gs-c-l {
						width: 60%;
		
						img {
							width: 100%;
						}
		
						.gs-c-l-f {
							margin-top: 24px;
							display: flex;
		
							.item {
								flex: 1;
								text-align: center;
		
								.item-h {
									font-weight: 400;
									font-size: 24px;
		
									span {
										font-size: 14px;
									}
								}
		
								.item-f {
									font-weight: 400;
									font-size: 15px;
								}
							}
						}
					}
		
					.gs-c-r {
						width: calc(40% - 20px);
						display: flex;
		
						.title {
							font-weight: 500;
							font-size: 20px;
							margin-bottom: 8px;
						}
		
						.sec {
							font-weight: 400;
							font-size: 14px;
						}
		
						.more {
							margin-top: 30px;
							width: 100%;
							display: flex;
		
							div {
								width: 180px;
								height: 48px;
								border: 1px solid #22A3D3;
								line-height: 48px;
								border-radius: 2px;
							}
						}
					}
				}
			}
		
			// 业务与服务
			.fw {
				width: 100%;
				display: flex;
				padding-bottom: 60px;
		
				.fw-cc {
					width: 100%;
				}
		
				.fw-h {
					height: 120px;
					line-height: 120px;
					font-size: 24px;
				}
		
				.fw-b {
					width: 100%;
					display: flex;
		
		            img {
						width: 80%;
						// height:544px;
						margin-top:30px;
						margin-bottom:16px;
					}
		
				}
		
				.fw-more {
					width: 100%;
					display: flex;
		
					div {
						width: 140px;
						height: 45px;
						border: 1px solid #22A3D3;
						line-height: 45px;
						border-radius: 2px;
					}
					
				}
			}
		
			//新闻媒体
			.mt {
				width: 100%;
				display: flex;
				padding: 0 20px 60px;
		
				.mt-cc {
					width: 100%;
				}
		
				.mt-h {
					height: 120px;
					line-height: 120px;
					font-size: 24px;
				}
		
				.mt-b {
					width: 100%;
					display: flex;
					justify-content: space-between;
		
					.item {
						width: calc(33.33% - 10px);
		
						img {
							width: 100%;
							height: 260px;
						}
		
						.item-t {
							margin-top: 20px;
							font-size: 18px;
						}
		
						.item-s {
							margin-top: 12px;
							font-size: 15px;
						}
					}
		
				}
		
				.mt-more {
					width: 100%;
					display: flex;
		
					div {
						width: 180px;
						height: 45px;
						border: 1px solid #22A3D3;
						line-height: 45px;
						border-radius: 2px;
					}
				}
			}
		
			// 合作伙伴
			.hb {
				width: 100%;
				display: flex;
				padding-bottom: 60px;
				
		
				.hb-cc {
					width: 100%;
				}
		
				.hb-h {
					height: 140px;
					line-height: 140px;
					font-size: 24px;
				}
		
				.hb-b {
					width: 100%;
					display: flex;
					padding: 0 20px;
		
					img {
						width: 33.33%;
						height:16%;
						// height: 120px;
					}
		
		
				}
		
				.hb-more {
					width: 100%;
					display: flex;
		
					#morebtn {
						width: 180px;
						height: 45px;
						border: 1px solid #22A3D3;
						line-height: 45px;
						border-radius: 2px;
					}
				}
			}
		
			// 资质荣誉
			.ry {
				width: 100%;
				display: flex;
				padding-bottom: 60px;
		
				.ry-cc {
					width: 100%;
				}
		
				.ry-h {
					height: 140px;
					line-height: 140px;
					font-size: 24px;
				}
		
				.ry-b {
					width: 100%;
					display: flex;
		
					.ry-b-l,
					.ry-b-r {
						width: 40px;
						height: 40px;
					}
		
					.ry-b-c {
						width: calc(100% - 160px);
						display: flex;
		
						.item {
							width: calc(25% - 30px);
							display: flex;
		
							.item-h {
								width: 90%;;
								height: 180px;
							}
		
							.item-f {
								width: 100%;
								height: 80px;
							}
						}
		
					}
		
		
				}
		
				.ry-more {
					width: 100%;
					display: flex;		
					div {
						width: 180px;
						height: 45px;
						border: 1px solid #22A3D3;
						line-height: 45px;
						border-radius: 2px;
					}
				}
			}
		
			// 投资模式
			.tz {
		
				width: 100%;
				display: flex;
				padding-bottom: 60px;
		
				
		
				.tz-h {
					height: 140px;
					line-height: 140px;
					font-size: 32px;
				}
		
				.tz-b {
					width: 100%;
					display: flex;	
						padding: 0 20px;
					.item {
						width: calc(50% - 15px);
						height: 400px;
						padding: 30px;
						
						.bgimg {
							top: 0;
							left: 0;
							width: 100%;
							height: 400px;
						}
		
						.item-t {
							font-size: 24px;
						}
		
						.item-s {
							width: 100%;
							margin-top: 12px;
							font-size: 15px;
						}
		
						.item-b {
							margin-top: 24px;
							width: 180px;
							height: 45px;
							border: 1px solid #22A3D3;
							line-height: 45px;
							border-radius: 2px;
						}
					}
				}
			}
		}
		
		.swiper-container {
			width: 100%;
			height: auto;
			// height: 450px;
			.pagination {
				bottom: 10px;
				left:calc(50% - 150px);
				width: 300px;
				height: 20px;
				
				div {
					width: 18px;
					height: 5px;
					
					margin: 0 4px;
				}
				
			}
		}
		
		.swiper-slide {
			width: 100%;
			// height: 450px;
			
			.banner {
				width: 100%;
				height: 450px;
				display: flex;
				img {
					top: 0;
					left: 0;
					width: 100%;
					height: 450px;
				}
				div {
					width: 100%;
					font-size: 28px;
				}
			}
		}
		
		.swiper-pagination-bullet {
			width: 20px;
			height: 20px;
		}
	
	}
	@media screen and (max-width: 880px) {
		.content {
			padding-top: 50px;
			
			.banneren {
				.banner-sec {
					padding: 0 10px;
					div {
						font-size: 14px;
					}
				}
			}
		
			.gs {
				width: 100%;
				display: flex;
				padding-bottom: 40px;
				padding: 30px 12px 20px;
		
				.gs-cc {
					width: 100%;
					display: flex;
					flex-direction: column;
		
					.gs-c-l {
						width: 100%;
		
						img {
							width: 100%;
						}
		
						.gs-c-l-f {
							margin-top: 16px;
							display: flex;
		
							.item {
								flex: 1;
								text-align: center;
		
								.item-h {
									font-weight: 400;
									font-size: 15px;
		
									span {
										font-size: 14px;
									}
								}
		
								.item-f {
									font-weight: 400;
									font-size: 13px;
								}
							}
						}
					}
		
					.gs-c-r {
						margin-top: 15px;
						width: 100%;
						display: flex;
		
						.title {
							font-weight: 500;
							font-size: 16px;
							margin-bottom: 5px;
						}
		
						.sec {
							// margin-top: 10px;
							font-weight: 400;
							font-size: 13px;
						}
		
						.more {
							margin-top: 20px;
							width: 100%;
							display: flex;
		
							div {
								width: 120px;
								height: 45px;
								border: 1px solid #22A3D3;
								line-height: 45px;
								border-radius: 2px;
							}
						}
					}
				}
			}
		
			// 业务与服务
			.fw {
				width: 100%;
				display: flex;
				padding-bottom: 40px;
		
				.fw-cc {
					width: 100%;
				}
		
				.fw-h {
					height: 90px;
					line-height: 90px;
					font-size: 20px;
				}
		
				.fw-b {
					width: 100%;
					display: flex;
		
		            img {
						width: 80%;
						// height:544px;
						margin-top:20px;
						margin-bottom:14px;
					}
		
				}
		
				.fw-more {
					width: 100%;
					display: flex;
		
					div {
						width: 120px;
						height: 45px;
						border: 1px solid #22A3D3;
						line-height: 45px;
						border-radius: 2px;
					}
				}
			}
		
			//新闻媒体
			.mt {
				width: 100%;
				display: flex;
				padding: 0 20px 40px;
		
				.mt-cc {
					width: 100%;
				}
		
				.mt-h {
					height: 90px;
					line-height: 90px;
					font-size: 20px;
				}
		
				.mt-b {
					width: 100%;
					display: flex;
					justify-content: space-between;
		
					.item {
						width: calc(33.33% - 10px);
						 transition: transform 0.3s;
		
						img {
							width: 100%;
							height: 120px;
						}
		
						.item-t {
							margin-top: 12px;
							font-size: 14px;
						}
		
						.item-s {
							margin-top: 12px;
							font-size: 12px;
						}
					}
					.item:hover {
					       transition: width 0.3s, height 0.3s;
					       transform: scale(0.95);
					       
					      }
		
				}
		
				.mt-more {
					width: 100%;
					display: flex;
		
					div {
						width: 120px;
						height: 45px;
						border: 1px solid #22A3D3;
						line-height: 45px;
						border-radius: 2px;
					}
				}
			}
		
			// 合作伙伴
			.hb {
				width: 100%;
				display: flex;
				padding-bottom: 40px;
				
		
				.hb-cc {
					width: 100%;
				}
		
				.hb-h {
					height: 90px;
					line-height: 90px;
					font-size: 20px;
				}
		
				.hb-b {
					width: 100%;
					display: flex;
					padding: 0 12px;
		
					img {
						width: 33.33%;
						height:16%;
						// height: 120px;
					}
		
		
				}
		
				.hb-more {
					width: 100%;
					display: flex;
		
					#morebtn {
						width: 180px;
						height: 45px;
						border: 1px solid #22A3D3;
						line-height: 45px;
						border-radius: 2px;
					}
				}
			}
		
			// 资质荣誉
			.ry {
				width: 100%;
				display: flex;
				padding-bottom: 40px;
		
				.ry-cc {
					width: 100%;
				}
		
				.ry-h {
					height: 100px;
					line-height: 100px;
					font-size: 20px;
				}
		
				.ry-b {
					width: 100%;
					display: flex;
					justify-content: space-between;
		
					.ry-b-l,
					.ry-b-r {
						display: none;
						width: 20px;
						height: 20px;
					}
		
					.ry-b-c {
						width: 100%;
						display: flex;
						flex-wrap: wrap;
		
						.item {
							width: calc(50% - 12px);
							display: flex;
		
							.item-h {
								width: 90%;
								height: 140px;
							}
		
							.item-f {
								width: 100%;
								height: 60px;
							}
						}
		
					}
		
		
				}
		
				.ry-more {
					width: 100%;
					display: flex;		
					div {
						width: 160px;
						height: 45px;
						border: 1px solid #22A3D3;
						line-height: 45px;
						border-radius: 2px;
					}
				}
			}
		
			// 投资模式
			.tz {
		
				width: 100%;
				display: flex;
				padding-bottom: 40px;
		
				
		
				.tz-h {
					height: 100px;
					line-height: 100px;
					font-size: 20px;
				}
		
				.tz-b {
					width: 100%;
					display: flex;	
						padding: 0 20px;
						flex-wrap: wrap;
						
					.item {
						width: 100%;
						height: 300px;
						padding: 20px;
						margin-bottom: 12px;
						
						.bgimg {
							top: 0;
							left: 0;
							width: 100%;
							height: 300px;
						}
		
						.item-t {
							font-size: 18px;
						}
		
						.item-s {
							width: 100%;
							margin-top: 12px;
							font-size: 15px;
						}
		
						.item-b {
							margin-top: 24px;
							width: 160px;
							height: 45px;
							border: 1px solid #22A3D3;
							line-height: 45px;
							border-radius: 2px;
						}
					}
				}
			}
		}
		
		.swiper-container {
			width: 100%;
			// height: auto;
			height: 380px !important;
			.pagination {
				bottom: 0px;
				left:calc(50% - 150px);
				width: 300px;
				height: 20px;
				
				div {
					width: 12px;
					height: 4px;
					
					margin: 0 2px;
				}
				
			}
			img {
				width: 100%;
				height: 380px;
				object-fit: unset !important;
			}
		}
		
		.swiper-slide {
			width: 100%;
			height: 380px !important;
			
			.banner {
				width: 100%;
				// height: 380px;
				display: flex;
				img {
					top: 0;
					left: 0;
					width: 100%;
					height: 380px;
				}
				div {
					width: 100%;
					font-size: 28px;
				}
			}
		}
		
		.swiper-pagination-bullet {
			width: 20px;
			height: 20px;
		}
	
	}
</style>
